<template>
    <div class="margin_horizontal">
        <div class="pageTitle">
            <span class="md-title">{{ $t("management.invoices.title") }}</span>
        </div>
		<div class="short_table_description table_description_filter">
			<div class="tertiary_color text_left" v-html="$t('management.invoices.headTip', {url: this.priceListLink})">
			</div>
		</div>
        <div class="flex filter_table">
            <div class="flex flex_column w_100">
                <ag-item :rowData="rowData"
                         :columnDefs="columnDefs"
                         v-on:sortChanged="sortChanged"
                         :with-title="true"
						 :with-short-description="true"
                />
                <Pagination
                    :totalNum="totalNum"
                    :pageSize="pageSize"
                    :sizeChange="sizeChange"
                    :currentChange="currentChange"
                    :currentPage="page"
                ></Pagination>
            </div>
             <InvoicesFilter @apply-filter="applyFilter"/>
        </div>
    </div>
</template>

<script>
import AgItem from "@/components/templates/agGrid/AgItem";
import InvoicesFilter from "@/components/templates/invoices/InvoicesFilter";
import {invoiceManagementApi} from "@/common/api/invoiceManagementApi";
import {enumDef} from "@/common/enumDefs";
import {asLocalizedDate, asMoneyAmount} from "@/components/templates/agGrid/formatter/valueFormatters";
import PaginationParent from "@/components/templates/common/PaginationParent";
import Pagination from "@/components/templates/common/Pagination";
import APP from "@/common/appConfig";
import {localization} from "@/common/lang/localization";

export default {
    extends: PaginationParent,
    components: {
        AgItem,
        InvoicesFilter,
        Pagination
    },
    data() {
        return {
            activeTab: "invoice",
            filters: [],
            sorting: [],
            rowData: [],
            columnDefs: []
        };
    },
    beforeMount() {
        this.getColumnDef();
        this.getList();
    },
    methods: {
        getColumnDef() {
            this.columnDefs = [
                {
                    headerName: this.$t("management.invoices.table.header.date"),
                    field: "invoiceCreationDate",
                    valueFormatter: asLocalizedDate(),
                    sortable: true,
                    minWidth: 100,
                    sort: "desc"
                },
                {
                    headerName: this.$t("management.invoices.table.header.invoiceNumber"),
                    field: "invoiceNumber",
                    sortable: true,
                    minWidth: 150,
                },
                {
                    headerName: this.$t("management.invoices.table.header.type"),
                    field: "type",
                    cellRendererFramework: "EnumAsText",
                    enumDef: this.activeTab === "invoice" ? enumDef.invoiceType : enumDef.creditNoteType,
                    minWidth: 70,
                    sortable: true,
                },
                {
                    headerName: this.$t("management.invoices.table.header.amount"),
                    headerClass: "align-right",
                    field: "amount",
                    cellStyle: {'justify-content': 'flex-end'},
                    valueFormatter: asMoneyAmount(),
                    sortable: true,
                    minWidth: 150,
                },
                {
                    headerName: this.$t("management.invoices.table.header.files"),
                    cellRendererFramework: "InvoiceOperationRender",
                    pinned: "right",
                    minWidth: 50,
                },
            ];
        },
        applyFilter(filters) {
            this.filters = filters;
            this.getList();
        },
        sortChanged(sortData) {
            this.sorting = sortData;
            this.initPage();
            this.getList();
        },
        getList() {
            let option = {
                columns: [],
                filters: this.filters || [],
                maxResults: this.maxResults,
                offset: this.offset,
                sorting: this.sorting
            };

            invoiceManagementApi.inspection.listInvoices(option)
                .then(res => {
                    if (res) {
                        this.setTotalNum(res.recordsTotal);
                        this.rowData = res.data;
                    }
                })
                .catch(e => {
                    this.toast(e);
                });
        },
    },
	computed: {
		priceListLink() {
			return APP.DOMAIN + "platformdoc/pricelist";
		}
	}
};

</script>